<div id="container-fluid" class="grid-container">

  <div class="row row-size">
    <div class="col-12 col-pad">



      <mat-card class="dash-mat-card">
        <mat-card-title class="title-spacing">
          <span class="dash-mat-card-line"> </span>
          <span class="dash-mat-card-title">Hotspot Overview</span>
        </mat-card-title>

        <mat-card-content style="width:100%">

          <div class="row card1-content">
            <div class="col-12 col-no-margin">
              <div class="chip">
                <div class="chip-title">Online</div>
                <div class="chip-content">{{globals.online}}/{{globals.fullDeviceList.length}}</div>
                <div class="chip-progress">
                  <mat-progress-bar class="success-progress" mode="determinate"
                    [value]="globals.online/globals.fullDeviceList.length*100"></mat-progress-bar>
                </div>
              </div>
            </div>
            <!-- <div class="col-6 col-no-margin">
              <div class="chip">
                <div class="chip-title">Synced</div>
                <div class="chip-content">{{globals.synced}}/{{globals.fullDeviceList.length}}</div>
                <div class="chip-progress">
                  <mat-progress-bar class="info-progress" mode="determinate"
                    [value]="globals.synced/globals.fullDeviceList.length*100"></mat-progress-bar>
                </div>
              </div>
            </div> -->
            <!-- <div class="col-4 col-no-margin">
              <div class="chip">
                <div class="chip-title">Relayed</div>
                <div class="chip-content">{{globals.relayed}}/{{globals.fullDeviceList.length}}</div>
                <div class="chip-progress">
                  <mat-progress-bar class="warning-progress" mode="determinate"
                    [value]="globals.relayed/globals.fullDeviceList.length*100"></mat-progress-bar>
                </div>
              </div>
            </div> -->

          </div>


        </mat-card-content>
      </mat-card>

    </div>
  </div>
  <div class="row row-size">
    <div class="col-12 col-pad">

      <mat-card class="dash-mat-card">
        <mat-card-title class="title-spacing">
          <span class="dash-mat-card-line"> </span>
          <span class="dash-mat-card-title">Rewards Overview (HNT)</span>
        </mat-card-title>
        <mat-card-content style="width:100%">

          <div class="row card1-content">
            <div class="col-lg-3 col-md-6 col-xs-12 col-sm-12 col-no-margin">
              <div class="chip">
                <div class="chip-title">Last 24h</div>
                <div class="chip-content">{{globals.rewards.total.day.toFixed(8)}}</div>

              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12 col-no-margin">
              <div class="chip">
                <div class="chip-title">Last 7d</div>
                <div class="chip-content">{{globals.rewards.total.week.toFixed(8)}}</div>

              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12  col-no-margin">
              <div class="chip">
                <div class="chip-title">Last 30d</div>
                <div class="chip-content">{{globals.rewards.total.month.toFixed(8)}}</div>

              </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12  col-no-margin">
              <div class="chip">
                <div class="chip-title">Total</div>
                <div class="chip-content">{{globals.rewards.total.total.toFixed(8)}}</div>

              </div>
            </div>

          </div>


        </mat-card-content>
      </mat-card>
    </div>

  </div>
  <div class="row row-size">
    <div class="col-lg-5 col-md-6 col-pad">

      <mat-card class="dash-mat-card ">
        <mat-card-title class="title-spacing" style="width: 100%; display: flex; align-items: center;">
          <span class="dash-mat-card-line"> </span>
          <span class="dash-mat-card-title-1">Firmware Version: {{showMinerVersion?'Helium Miner':'Proton'}}</span>
          <span style=flex:auto></span>
          <span class="material-icons float-right dash-mat-card-button" (click)="toggleVersion(true)">
            arrow_back_ios
            </span>
          <span class="material-icons float-right dash-mat-card-button" (click)="toggleVersion()">
            arrow_forward_ios
            </span>
        </mat-card-title>
        <mat-card-subtitle class="height-1" >

          <!-- <div   class="row" style="width:100%;height:100%;"> -->
           
           

            
            <div id="carouselExampleSlidesOnly" class="carousel slide" data-ride="carousel">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <div  class="col-12"> 
                    <div id="fw-versions" style="width:100%;height:100%;"></div>
                  </div>                
                </div>
                <div class="carousel-item ">
                  <div   class="col-12" style="overflow-x:scroll;" > 
                    <div id="fw-versions-1" style="width:100%;height:100%"></div>
                  </div>
                 </div>
            
              </div>
            </div>
           
          <!-- </div> -->

          <!-- <div   class="row" style="width:100%;height:40%;">
            
           
          </div> -->
    

        </mat-card-subtitle>
      </mat-card>

    </div>
    <div class="col-lg-7 col-md-6 col-pad">

      <mat-card class="dash-mat-card  ">
        <mat-card-title class="title-spacing">
          <span class="dash-mat-card-line"> </span>
          <span class="dash-mat-card-title">Device Explorer</span>
        </mat-card-title>
        <mat-card-subtitle class="height-2">
          <div class="map" id="map" class="match-parent"></div>


        </mat-card-subtitle>
      </mat-card>
    </div>
  </div>


</div>
